import { render, staticRenderFns } from "./HealthAssessment.vue?vue&type=template&id=1674ccdb&scoped=true"
import script from "./HealthAssessment.vue?vue&type=script&lang=js"
export * from "./HealthAssessment.vue?vue&type=script&lang=js"
import style0 from "./HealthAssessment.vue?vue&type=style&index=0&id=1674ccdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674ccdb",
  null
  
)

export default component.exports